import { h } from '../lib/dom.js';
import { getState } from '../store.js';
import { setVerifyBackupAnswer, skipVerifyBackup, submitVerifyBackup } from '../actions.js';
import { t } from '../i18n/index.js';

// Guided backup ceremony (feature-harden.md CCSS-BR): challenges the user
// on 3 random word positions to confirm they actually wrote the phrase
// down. "Skip for now" is always present and always works -- this never
// gates reveal, hide, or anything else in the app (user instruction,
// 2026-08-05).
export function renderVerifyBackupModal() {
  const s = getState();
  if (!s.showVerifyBackup) return null;

  const rows = s.verifyBackupIndices.map((wordNum, slot) =>
    h('div', { class: 'field-row' }, [
      h('span', { class: 'verify-backup-word-label' }, t('modals.verifyBackup.wordLabel', { n: wordNum })),
      h('input', {
        class: 'verify-backup-input',
        value: s.verifyBackupAnswers[slot] || '',
        autocomplete: 'off', autocapitalize: 'off', spellcheck: 'false',
        oninput: (e) => setVerifyBackupAnswer(slot, e.target.value)
      })
    ])
  );

  return h('div', { class: 'modal-scrim' }, [
    h('div', { class: 'modal-card' }, [
      h('div', { class: 'modal-title' }, t('modals.verifyBackup.title')),
      h('div', { class: 'text-muted modal-help' }, t('modals.verifyBackup.help')),
      h('div', { class: 'stack' }, rows),
      h('div', { class: 'field-error' }, s.verifyBackupError || ''),
      h('div', { class: 'btn-row' }, [
        h('button', { class: 'btn btn-secondary', onclick: skipVerifyBackup }, t('modals.verifyBackup.skip')),
        h('button', { class: 'btn btn-primary', onclick: submitVerifyBackup }, t('modals.verifyBackup.confirm'))
      ])
    ])
  ]);
}
